import { render } from "./GeoComuni.vue?vue&type=template&id=72105a5f&scoped=true"
import script from "./GeoComuni.vue?vue&type=script&lang=js"
export * from "./GeoComuni.vue?vue&type=script&lang=js"

import "./GeoComuni.vue?vue&type=style&index=0&id=72105a5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72105a5f"]])

export default __exports__